module.exports = __webpack_public_path__ + "img/email-icon.5446a4c7.svg";